import { ITipoAtividades } from "../../../Interfaces/Geral/TipoAtividades";
import {
    DeletarTipoAtividadesService,
    InserirTipoAtividadesService,
    UptadeTipoAtividadesService,
    listarTipoAtividadesService,
} from "../../../Services/TipoAtividades/TipoAtividades";
import { Controller } from "../../Controller";

export async function listarTipoAtividadesController(
    ID_TIPO_CASO: number,
    DS_PESQUISA: string
) {
    return Controller(listarTipoAtividadesService(ID_TIPO_CASO, DS_PESQUISA));
}

export async function DeletarTipoAtividadesController(
    ID_TIPO_ATIVIDADE: number
) {
    return Controller(DeletarTipoAtividadesService(ID_TIPO_ATIVIDADE));
}

export async function UptadeTipoAtividadesController(
    requestBody: ITipoAtividades
) {
    return Controller(UptadeTipoAtividadesService(requestBody));
}

export async function InserirTipoAtividadesController(
    requestBody: ITipoAtividades
) {
    return Controller(InserirTipoAtividadesService(requestBody));
}
